import { Link } from "react-router-dom";
import Button from "./Button";

type Props = {
  name: string;
  organizationId: string;
  moduleId: string;
  edit?: boolean;
};

export default function ModuleSelector({
  name,
  organizationId,
  moduleId,
  edit,
}: Props) {
  return (
    <Link
      className="cursor-pointer"
      to={`${
        edit ? "producer/" : ""
      }organization/${organizationId}/module/${moduleId}`}
    >
      <Button label={name} className="p-4 m-2 w-full text-2xl" />
    </Link>
  );
}
